import React, { useCallback, useContext, useState } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { apiFetch } from 'functions.js';

// CORE COMPONENTS
import Form from 'core/form/Form.js';

// CONTEXT
import { ListContext } from 'helpers/getListData';

// MAIN COMPONENT
const CommentForm = ({ taskID, rowNumber }) => {
  // CONTEXT
  const { updateContext } = useContext(ListContext);

  // STATE
  const [value, setValue] = useState();
  const [error, setError] = useState(false);

  // CALLBACKS
  const handleChange = useCallback(
    e => {
      setValue(e.target.value)
      setError(false);
    },
    [setValue, setError]
  );
  const handleClick = useCallback(() => {
    if (!value) setError(true);
    else apiFetch({
      method: 'POST',
      endpoint: ENDPOINTS.dealTasks.comment.add,
      params: {
        task_id: taskID,
        comments: value
      },
      loadingMessage: 'Adding comment',
      errorMessage: 'Unable to add comment.',
      onSuccess: () => {
        updateContext({ type: 'updateSettings', reloadRow: rowNumber });
        setValue();
      }
    });
  }, [taskID, value, updateContext, rowNumber]);

  // RENDER
  return (
    <Form.Control
      placeholder="Add a comment"
      value={value}
      onChange={handleChange}
      append={{
        use: 'send',
        onClick: handleClick
      }}
      useFormik={false}
      showFeedback
      hasError={error}
      error={error && 'A comment is required.'}
      fullWidth
      formGroup={{
        className: 'p-0'
      }}
      size="sm"
    />
  );
};

// EXPORT
export default CommentForm;
